import auth0 from 'auth0-js'

import { getContentForMarket } from './market'
import { getSlug } from './slugs'
import { extendUrlByUtmParams } from './utm'

const NEXT_AUTH0_CLIENT_ID = process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID
const NEXT_AUTH0_DOMAIN = process.env.NEXT_PUBLIC_AUTH0_DOMAIN

export const getUrl = ({ navItem, slugPrefix, navigationItems = {}, isNotification = false }) => {
  try {
    if (!navItem || process.env.PREVIEW_MODE === 'true') {
      return '#'
    }

    const { externalUrl, content: contentC, relativePath, sendUtmParams } = navItem
    const content = contentC || navItem?.content || []

    // External url takes precedence
    if (externalUrl) {
      return extendUrlByUtmParams(externalURLBuilder(externalUrl, slugPrefix), sendUtmParams)
    }

    if (typeof isNotification === 'boolean' && isNotification) {
      return extendUrlByUtmParams(
        internalURLBuilder(navItem.content, slugPrefix, navItem.relativePath, isNotification)
      )
    }

    if (!externalUrl && !relativePath && content?.length > 0) {
      // Map id to the correct
      const pattern = /(?<=\/|^)[a-zA-Z]+(?=\/|-|$)/
      const id = navItem?.sys?.id || navItem.id
      const currentLanguage = slugPrefix?.match(pattern)[0]

      const navigationItem = navigationItems[currentLanguage]
        ? navigationItems[currentLanguage][id]
        : {}
      if (navigationItem) {
        return extendUrlByUtmParams(
          internalURLBuilder(navigationItem.content, slugPrefix, relativePath),
          sendUtmParams
        )
      }
    }

    // if content is an array and has at least 1 item
    const pattern = /(?<=\/|^)[a-zA-Z]+(?=\/|-|$)/
    const id = navItem?.sys?.id || navItem.id
    const currentLanguage = slugPrefix?.match(pattern)[0]
    if (!currentLanguage) {
      return '/not-found'
    }
    const navigationItem = navigationItems[currentLanguage]
      ? navigationItems[currentLanguage][id]
      : {}

    return extendUrlByUtmParams(
      internalURLBuilder(navigationItem?.content || content, slugPrefix, relativePath),
      sendUtmParams
    )
  } catch (e) {
    console.error(navItem, slugPrefix, e)
    return '/not-found'
  }
}

function externalURLBuilder(externalUrl, slugPrefix) {
  const startingWords = ['tel:', 'mailto', 'http', slugPrefix, `/${slugPrefix}`]
  const isStartsWith = startingWords.some((word) => externalUrl.startsWith(word))

  if (isStartsWith && externalUrl.includes('createaccount')) {
    return auth0UrlBuilder(externalUrl)
  }

  if (isStartsWith) {
    return externalUrl
  }

  return `/${slugPrefix}/${externalUrl}`.replace(/\/\//g, '/')
}

function internalURLBuilder(content, slugPrefix, relativePath, isNotification = false) {
  if (Array.isArray(content) && content.length > 0 && !isNotification) {
    const contentToUse = getContentForMarket(content, slugPrefix)
    return getSlug(contentToUse, slugPrefix)

    // otherwise if content is set and has a slug
  } else if (content && content.slug && !isNotification) {
    return getSlug(content, slugPrefix)
  }

  // for notification bar
  if (content && Array.isArray(content) && content[0] && isNotification) {
    const { slug, customerSlug, customerTypeSlug, careersSlug, blogSlug, integrationSlug } =
      content[0]

    if (typeof customerSlug === 'string') {
      return `/${slugPrefix}/customers/${customerSlug}`.replace(/\/\//g, '/')
    }
    if (typeof customerTypeSlug === 'string') {
      return `/${slugPrefix}/customers/type/${customerTypeSlug}`.replace(/\/\//g, '/')
    }
    if (typeof careersSlug === 'string') {
      return `/en/careers/${careersSlug}`.replace(/\/\//g, '/')
    }
    if (typeof blogSlug === 'string') {
      return `/${slugPrefix}/blog/${blogSlug}`.replace(/\/\//g, '/')
    }
    if (typeof integrationSlug === 'string') {
      return `/${slugPrefix}/integrations/${integrationSlug}`.replace(/\/\//g, '/')
    }

    return `/${slugPrefix}/${slug}`.replace(/\/\//g, '/')
  }

  if (relativePath) {
    return `/${slugPrefix}${relativePath}`.replace(/\/\//g, '/')
  }

  return '#'
}

function auth0UrlBuilder(externalUrl) {
  if (typeof window !== 'undefined') {
    const webAuth = new auth0.WebAuth({
      domain: NEXT_AUTH0_DOMAIN,
      clientID: NEXT_AUTH0_CLIENT_ID,
      action: 'signup'
    })

    return webAuth.client.buildAuthorizeUrl({
      clientID: NEXT_AUTH0_CLIENT_ID,
      responseType: 'token',
      redirectUri: externalUrl,
      screen_hint: 'signup',
      initialScreen: 'signUp',
      is_selfserve: true
    })
  }
}
